// extracted by mini-css-extract-plugin
export default {"container":"home-page_container__oDz2L"};